<ui-panel>
  <ui-panel-header>
    <ui-panel-title>Customer details</ui-panel-title>
  </ui-panel-header>
  <ui-panel-body class="detail-panel" *ngIf="detail">
    <ui-panel-display-info-row
      *ngFor="let row of detail"
      [data]="row"
      data-hook="customer-details-row"
    ></ui-panel-display-info-row>
  </ui-panel-body>
</ui-panel>
